/*
 *
 *  actions
 *
 */

import {
  LOAD_RECORDS_VALID_CACHE,
  LOAD_RECORDS_META_DATA,
  LOAD_RECORDS_META_DATA_SUCCESS,
  LOAD_RECORDS_META_DATA_ERROR,
  LOAD_EMPLOYEE,
  LOAD_EMPLOYEE_SUCCESS,
  LOAD_EMPLOYEE_ERROR,
  LOAD_NIGHTSHIFT_DETAIL,
  LOAD_NIGHTSHIFT_DETAIL_SUCCESS,
  LOAD_NIGHTSHIFT_DETAIL_ERROR,
  LOAD_UPDATE_NIGHTSHIFT,
  LOAD_UPDATE_NIGHTSHIFT_SUCCESS,
  LOAD_UPDATE_NIGHTSHIFT_ERROR,
  UPDATE_LPND,
  UPDATE_LPND_SUCCESS,
  UPDATE_LPND_ERROR,
  DELETE_RECORD,
  DELETE_RECORD_ERROR,
  DELETE_RECORD_SUCCESS,

  APPLY_NIGHT_SHIFT_DETAILS,
  APPLY_NIGHT_SHIFT_DETAILS_SUCCESS,
  APPLY_NIGHT_SHIFT_DETAILS_ERROR,
} from "./constants"

export function loadRecordsCacheHit() {
  return {
    type: LOAD_RECORDS_VALID_CACHE,
  }
}

export function loadRecordsMetaData() {
  return {
    type: LOAD_RECORDS_META_DATA,
  }
}

/**
 *
 * @param {object} recordsMetaData
 * @returns
 */
export function loadRecordsMetaDataSuccess(recordsMetaData) {
  return {
    type: LOAD_RECORDS_META_DATA_SUCCESS,
    recordsMetaData,
  }
}

/**
 *
 * @param {string} error
 * @returns
 */
export function loadRecordsMetaDataError(error) {
  return {
    type: LOAD_RECORDS_META_DATA_ERROR,
    error,
  }
}

//Employee list
/**
 *
 * @param {integer} id
 * @returns
 */
export function loadEmployee() {
  return {
    type: LOAD_EMPLOYEE,
  }
}

export function loadEmployeeSuccess(employee_list) {
  return {
    type: LOAD_EMPLOYEE_SUCCESS,
    employee_list,
  }
}

/**
 * @param {string} error
 */

export function loadEmployeeError(error) {
  return {
    type: LOAD_EMPLOYEE_ERROR,
    error,
  }
}

// nightshift details
export function loadNightShiftDetail(applyFilter) {
  return {
    type: LOAD_NIGHTSHIFT_DETAIL,
    applyFilter,
  }
}

export function loadNightShiftDetailSuccess(nightshift_applies) {
  return {
    type: LOAD_NIGHTSHIFT_DETAIL_SUCCESS,
    nightshift_applies,
  }
}

export function loadNightShiftDetailError(error) {
  return {
    type: LOAD_NIGHTSHIFT_DETAIL_ERROR,
    error,
  }
}

//UPDATE NIGHTSHIFT
export function loadUpdateNightShift(update_Nightshift) {
  return {
    type: LOAD_UPDATE_NIGHTSHIFT,
    update_Nightshift,
  }
}

export function loadUpdateNightShiftSuccess(update_Nightshift) {
  return {
    type: LOAD_UPDATE_NIGHTSHIFT_SUCCESS,
    update_Nightshift,
  }
}

export function loadUpdateNightShiftError(error) {
  return {
    type: LOAD_UPDATE_NIGHTSHIFT_ERROR,
    error,
  }
}
//lpnd status
export function updateLpndStatus(update_Lpnd) {
  return {
    type: UPDATE_LPND,
    update_Lpnd,
  }
}

export function updateLpndStatusSuccess(update_Lpnd) {
  return {
    type: UPDATE_LPND_SUCCESS,
    update_Lpnd,
  }
}

export function updateLpndStatusError(error) {
  return {
    type: UPDATE_LPND_ERROR,
    error,
  }
}

//
export function deleteRecord(deleteData) {
  return {
    type: DELETE_RECORD,
   deleteData
  }
}

/**
 * 
 * @param {integer} id 
 * @param {string} success 
 * @returns 
 */
export function deleteRecordSuccess(id, success) {
  return {
    type: DELETE_RECORD_SUCCESS,
    id,
    success
  }
}

/**
 * @param {string} error 
 */
export function deleteRecordError(error) {
  return {
    type: DELETE_RECORD_ERROR,
    error
  }
}


//Apply Delegations details
/**
 *
 * @param {integer} id
 * @returns
 */
export function applyNightShiftList(applyNightShiftDetails) {
  return {
    type: APPLY_NIGHT_SHIFT_DETAILS,
    applyNightShiftDetails,
  }
}

export function applyNightShiftListSuccess(applyNightShiftDetails, success) {
  return {
    type: APPLY_NIGHT_SHIFT_DETAILS_SUCCESS,
    applyNightShiftDetails,
    success,
  }
}

/**
 * @param {string} error
 */

export function applyNightShiftListError(error) {
  return {
    type: APPLY_NIGHT_SHIFT_DETAILS_ERROR,
    error,
  }
}

const actions = {
  loadRecordsCacheHit,
  loadRecordsMetaData,
  loadRecordsMetaDataSuccess,
  loadRecordsMetaDataError,

  loadEmployee,
  loadEmployeeSuccess,
  loadEmployeeError,

  loadNightShiftDetail,
  loadNightShiftDetailSuccess,
  loadNightShiftDetailError,

  loadUpdateNightShift,
  loadUpdateNightShiftSuccess,
  loadUpdateNightShiftError,

  updateLpndStatus,
  updateLpndStatusSuccess,
  updateLpndStatusError,

  deleteRecord,
  deleteRecordSuccess,
  deleteRecordError,

  applyNightShiftList,
  applyNightShiftListSuccess,
  applyNightShiftListError,
}

export default actions
